import TRUCK_TYPES from "../assets/truck_types.js";

export const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatMiles = (value) => {
  const numberValue = toNumber(value);
  if (numberValue === null) return null;
  return `${Math.round(numberValue).toLocaleString()} mi`;
};

export const formatWeight = (value) => {
  const numberValue = toNumber(value);
  if (numberValue === null) return null;
  return `${Math.round(numberValue).toLocaleString()} lbs`;
};

export const formatCurrency = (value) => {
  const numberValue = toNumber(value);
  if (numberValue === null) return null;
  return `$${numberValue.toLocaleString()}`;
};

export const computeRatePerMile = (payment, miles) => {
  const paymentValue = toNumber(payment);
  const milesValue = toNumber(miles);
  if (paymentValue === null || milesValue === null || milesValue <= 0) {
    return null;
  }
  return paymentValue / milesValue;
};

export const normalizeEquipmentCode = (value) => {
  if (!value) return "";
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  const parenMatch = trimmed.match(/\(([^)]+)\)$/);
  if (parenMatch) {
    return parenMatch[1].trim();
  }
  if (trimmed.length <= 3) {
    return trimmed.toUpperCase();
  }
  return trimmed;
};

export const getTruckTypeLabel = (input) => {
  const normalizedCode = normalizeEquipmentCode(input);
  if (!normalizedCode) {
    return typeof input === "string" && input.trim() ? input.trim() : "—";
  }

  const truckType = TRUCK_TYPES.find(
    (type) => type.value === normalizedCode || type.label === normalizedCode,
  );

  if (truckType) {
    return truckType.label;
  }

  if (typeof input === "string" && input.trim()) {
    return input.trim();
  }

  return normalizedCode;
};

export const formatDateDisplay = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatTimeDisplay = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
};

export const buildGoogleMapsUrl = (
  originCity,
  originState,
  destinationCity,
  destinationState,
) => {
  const origin = encodeURIComponent(
    [originCity, originState].filter(Boolean).join(", "),
  );
  const destination = encodeURIComponent(
    [destinationCity, destinationState].filter(Boolean).join(", "),
  );
  return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`;
};

